import { defaultButtonTheme } from "../components/Button/theme";
import base from "./base";
import type { CarryTheme, Colors } from "./types";

const contrastColors: Colors = {
  // High contrast with bright text on black background
  GRAYSCALE_25: "rgb(255, 253, 2)",
  GRAYSCALE_50: "#EEEEEE",
  GRAYSCALE_100: "#DDDDDD",
  GRAYSCALE_200: "#BBBBBB",
  GRAYSCALE_300: "#888888",
  GRAYSCALE_400: "#666666",
  GRAYSCALE_500: "#444444",
  GRAYSCALE_600: "#333333",
  GRAYSCALE_700: "#222222",
  GRAYSCALE_800: "#111111",
  GRAYSCALE_900: "#000000",

  // Bright colors for dark background contrast
  PRIMARY_25: "rgb(255, 253, 2)",
  PRIMARY_50: "#99FFFF",
  PRIMARY_100: "#66EEFF",
  PRIMARY_200: "#33DDFF",
  PRIMARY_300: "#00CCFF",
  PRIMARY_400: "#0099FF",
  PRIMARY_500: "#444444",
  PRIMARY_600: "#333333",
  PRIMARY_700: "#222222",
  PRIMARY_800: "#111111",
  PRIMARY_900: "#000000",

  // Bright special colors for contrast
  SPECIAL_25: "rgb(255, 253, 2)",
  SPECIAL_50: "#99FFDD",
  SPECIAL_100: "#66FFCC",
  SPECIAL_200: "#33FFBB",
  SPECIAL_300: "#00FFAA",
  SPECIAL_400: "#00FF99",
  SPECIAL_500: "#444444",
  SPECIAL_600: "#333333",
  SPECIAL_700: "#222222",
  SPECIAL_800: "#111111",
  SPECIAL_900: "#000000",

  // Bright error colors for contrast
  ERROR_25: "rgb(255, 253, 2)",
  ERROR_50: "#FFDDDD",
  ERROR_100: "#FFCCCC",
  ERROR_200: "#FF9999",
  ERROR_300: "#FF6666",
  ERROR_400: "#FF3333",
  ERROR_500: "#444444",
  ERROR_600: "#333333",
  ERROR_700: "#222222",
  ERROR_800: "#111111",
  ERROR_900: "#000000",

  // Bright warning colors for contrast
  WARRING_25: "rgb(255, 253, 2)",
  WARRING_50: "#FFFF99",
  WARRING_100: "#FFEE66",
  WARRING_200: "#FFDD33",
  WARRING_300: "#FFCC00",
  WARRING_400: "#FFAA00",
  WARRING_500: "#444444",
  WARRING_600: "#333333",
  WARRING_700: "#222222",
  WARRING_800: "#111111",
  WARRING_900: "#000000",

  // Bright accent colors for contrast
  GOLD: "rgb(255, 253, 2)",
  BLUE: "#00CCFF",
  COUPON_BLUE: "#00CCFF",
  GREEN: "#00FF66",
  DARK_ORANGE: "#FF9900",

  // High contrast primitive colors
  BLACK: "#000000",
  WHITE: "rgb(255, 253, 2)",

  TRANSPARENT_WHITE_80: "rgba(255, 253, 2, 0.8)",
};

const contrastTheme: CarryTheme = {
  ...base,
  colors: contrastColors,
  button: defaultButtonTheme,
  backgrounds: {
    primary:
      "linear-gradient(111.98deg, rgba(0, 0, 0, 0.9) 5%, rgba(0, 0, 0, 0.95) 100%)",
    secondary: "#000000",
    secondaryTransparent: "rgba(0, 0, 0, 0.9)",
    theme: "#000000",
  },
  shadows: {
    active:
      "0px 0px 0px 2px rgb(255, 253, 2), 0px 0px 6px 10px rgba(255, 253, 2, 0.6)",
    success: "0px 0px 0px 2px #00FF66, 0px 0px 0px 6px rgba(0, 255, 102, 0.4)",
    warning: "0px 0px 0px 2px #FFCC00, 0px 0px 0px 6px rgba(255, 204, 0, 0.4)",
    focus:
      "0px 0px 0px 2px rgba(255, 253, 2, 0.8), 0px 0px 0px 4px rgb(255, 253, 2)",
    box: "2px 6px 8px 0px rgba(255, 253, 2, 0.4)",
    boxDark: "2px 6px 12px 0px rgba(255, 253, 2, 0.6)",
    select:
      "0 0 80px rgba(255, 253, 2, 0.6), 0 10px 20px rgba(255, 253, 2, 0.8)",
  },
};

export default contrastTheme;
